<template>
  <div class="organization">
    <!-- <h1>acquirer</h1> -->
    <v-snackbar
      v-model="snackbar"
      :timeout="6000"
      :color="snackbar_color"
      location="top"
      max-height="10cm"
      max-width="5cm"
      multi-line
    >
      {{ snackbar_text }}
    </v-snackbar>

    <v-row no-gutters>
      <v-col cols="auto" class="me-auto">
        <!-- <v-sheet class="ma-2 pa-2">Acquirer</v-sheet> -->
        <v-sheet>
          <v-breadcrumbs :items="['Capk']"></v-breadcrumbs>
        </v-sheet>
      </v-col>
      <v-col cols="1" class="mr-8">
        <v-sheet>
          <!-- <v-btn class="text-none text-subtitle-1" color="#5865f2" size="small" variant="flat" >Add Acquirer</v-btn>             -->
          <!-- <v-btn density="compact">Add Acquirer</v-btn>  -->
          <v-btn
            class="button_size"
            color="blue"
            prepend-icon="mdi-plus"
            @click="compose"
            v-if="
              this.global_permissions.includes('ROLE_MOD_CARD')              
            "
          >
            <template v-slot:prepend>
              <v-icon color="white"></v-icon>
            </template>
            Add capk
          </v-btn>
        </v-sheet>
      </v-col>
    </v-row>

    <v-row class="search_row pl-1">
      <v-col cols="3" class="ml-3">
        <v-text-field
          append-inner-icon="mdi-close-circle"
          append-icon="mdi-magnify"
          density="compact"
          label="Search"
          variant="solo"
          hide-details
          single-line
          dense
          v-model="query"
          @click:append-inner="resetData"
          @click:append="searchCapk"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- Loading Spinner -->
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="blue"
      size="25"
      class="loading-spinner"
    ></v-progress-circular>

    <v-container v-else class="m-0 p-0 pr-10">
      <v-row no-gutters>
        <v-col>
          <v-sheet>
            <v-card>
              <!-- <v-card-title>
                  
                  <v-spacer></v-spacer>
                  <v-row>
                    <v-col cols="4">                                 
                      <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>                                              
                    </v-col>
                    <v-col cols="4">                              
                      
                    </v-col>
                  </v-row>          
                </v-card-title> -->

              <v-data-table
                :headers="headers"
                :items="capks"
                class="elevation-1 custom-table-style"
                :search="search"
                :items-per-page="itemsPerPage"
                :items-length="totalItems"
                disable-pagination
                :hide-default-footer="true"
                :fixed-header="true"
                :loading="loading"
              > 

              <!-- FOR EXPANSION -->
              <template v-slot:expanded-row="{ columns, item }">
                      <!-- <tr>
                        <td :colspan="columns.length">               
                          More info about {{ item.value.deviceId }}
                        </td>
                      </tr> -->
                      <tr>
                        <td>{{ $t("acquirer") }}</td>
                        <td :colspan="columns.length" style="padding: 10px;">
                          <tr v-for="it in item.raw.acquirers" :key="it.id">
                            <td>{{ it.acquirerName }}</td>
                          </tr>
                          
                        </td>
                      </tr>
                      
                      
                    </template>

                <!-- Expiry Date Column -->
                <template v-slot:item.expiryDate="{ item }">
                  <!-- {{ JSON.stringify(item) }} -->
                  {{ formattedDate(item.raw.expiryDate) }}
                </template>  

                <template v-slot:item.acquirers="{ item }">
                  <td>
                    <tr v-for="it in item.raw.acquirers" :key="it.id">
                      <td>{{ it.acquirerName }}</td>
                    </tr>
                  </td>
                </template>

                <template v-slot:item.actions="{ item }">
                  <!-- <v-icon color="green" small class="mr-2" @click="compose_update(item.value.capkId)" v-if="this.global_permissions.includes('CONFIG_CARD_EDIT')">mdi-pencil</v-icon>
                      <v-icon color="red" small @click="compose_delete(item.value.capkId)" v-if="this.global_permissions.includes('CONFIG_CARD_DELETE')">mdi-delete</v-icon> -->
                  <v-tooltip :text="$t('Update')" location="top">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        v-bind="props"
                        color="green"
                        small
                        class="mr-2"
                        @click="compose_update(item.raw.id)"
                        v-if="
                          this.global_permissions.includes('ROLE_MOD_CARD')                          
                        "
                        >mdi-pencil-circle</v-icon
                      >
                    </template>
                  </v-tooltip>
                  <v-tooltip :text="$t('Delete')" location="top">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        v-bind="props"
                        small
                        color="red"
                        @click="compose_delete(item.raw.id)"
                        v-if="
                          this.global_permissions.includes('ROLE_DEL_CARD') ||
                          this.global_permissions.includes('ROLE_STAFF_ADMIN')
                        "
                        >mdi-delete-circle</v-icon
                      >
                    </template>
                  </v-tooltip>
                </template>

                <template v-slot:bottom>
                  <div class="text-center pt-2">
                    <v-pagination
                      v-model="page"
                      :length="pageCount"
                      total-visible="7"
                      @update:model-value="page"
                    ></v-pagination>
                  </div>
                </template>
              </v-data-table>
            </v-card>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>

    <!-- ADD DIALOG -->
    <v-dialog v-model="dialog" persistent width="800" max-height="800">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title class="d-flex justify-space-between ma-3">
              <span class="text-h5">Add CAPK</span>
              <v-icon @click="dialog = false"
                >mdi mdi-close-circle-outline</v-icon
              >
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      label="capkName*"
                      :readonly="loading"
                      :rules="[required, validateName]"
                      clearable
                      v-model="capk_data.f_capkName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <!-- <v-text-field label="rid*" :readonly="loading" :rules="[required, cakp_check]" clearable v-model="capk_data.f_rid" ></v-text-field> -->
                    <v-text-field
                      label="rid*"
                      :readonly="loading"
                      :rules="[required, validateField]"
                      clearable
                      v-model="capk_data.f_rid"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="keyIndex*"
                      :rules="[required]"
                      v-model="capk_data.f_keyIndex"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="hashIndicator*"
                      :rules="[required, validateMinMax]"
                      v-model="capk_data.f_hashIndicator"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="arithIndicator*"
                      :rules="[required, validateMinMax]"
                      v-model="capk_data.f_arithIndicator"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea
                      label="modulus*"
                      :readonly="loading"
                      :rules="[required, validateField]"
                      clearable
                      v-model="capk_data.f_modulus"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="modulusLength*"
                      :rules="[required]"
                      v-model="capk_data.f_modulusLength"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="exponent*"
                      :rules="[required]"
                      v-model="capk_data.f_exponent"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="exponentLength*"
                      :rules="[required]"
                      v-model="capk_data.f_exponentLength"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      label="expiryDate*"
                      placeholder="000000"
                      v-model="capk_data.f_expiryDate"
                      type="date"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      label="checksumValue*"
                      :rules="[required]"
                      v-model="capk_data.f_checksumValue"
                    ></v-text-field>
                  </v-col>
                  <!-- <v-col cols="12">                                 
                        <v-select
                          :items="organization"
                          item-title="orgName"
                          item-value="orgId"                          
                          label="Select Organization*"                          
                          :rules="[required]"
                          v-model="capk_data.f_orgId"
                        ></v-select>                      
                      </v-col> -->
                  <v-col cols="12">
                    <!-- <v-autocomplete
                      :items="acquirers"
                      item-title="name"
                      item-value="id"
                      label="Select Acquirers"
                      multiple
                      :rules="[required]"
                      v-model="capk_data.f_acquirerList"
                    ></v-autocomplete> -->

                    <v-select
                      v-model="capk_data.f_acquirerList"
                      :items="acquirers"
                      item-title="name"
                      item-value="id"
                      label="Select Acquirers"
                      multiple
                    >
                      <template v-slot:prepend-item>
                        <v-list-item title="Select All" @click="toggle">
                          <template v-slot:prepend>
                            <v-checkbox-btn
                              :color="likesSome ? 'indigo-darken-4' : undefined"
                              :indeterminate="likesSome && !likesAll"
                              :model-value="likesAll"
                            ></v-checkbox-btn>
                          </template>
                        </v-list-item>

                        <v-divider class="mt-2"></v-divider>
                      </template>
                    </v-select>

                  </v-col>
                </v-row>
              </v-container>
              <small>*{{ $t("indicateRequires") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog = false">{{
                $t("Close")
              }}</v-btn>
              <!-- <v-btn :disabled="!form" :loading="loading" color="success" type="submit" variant="text"  @click="addCapk" >Save</v-btn>   TO BE FIXED CHECK CAPK DOES NOT WORK WELL-->
              <v-btn
                color="success"
                type="submit"
                variant="text"
                @click="addCapk"
                >{{ $t("Save") }}</v-btn
              >
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END ADD DIALOG -->

    <!-- UPDATE  DIALOG -->
    <v-dialog v-model="dialog_update" persistent width="800">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title class="d-flex justify-space-between ma-3">
              <span class="text-h5">Update Capk</span>
              <v-icon @click="dialog_update = false"
                >mdi mdi-close-circle-outline</v-icon
              >
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      label="capkName*"
                      :readonly="loading"
                      :rules="[required, validateName]"
                      clearable
                      v-model="capk_data.f_capkName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      label="rid*"
                      :readonly="loading"
                      :rules="[required, validateField]"
                      clearable
                      v-model="capk_data.f_rid"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="keyIndex*"
                      :rules="[required]"
                      v-model="capk_data.f_keyIndex"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="hashIndicator*"
                      :rules="[required, validateMinMax]"
                      v-model="capk_data.f_hashIndicator"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="arithIndicator*"
                      :rules="[required, validateMinMax]"
                      v-model="capk_data.f_arithIndicator"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea
                      label="modulus*"
                      :rules="[required, validateField]"
                      v-model="capk_data.f_modulus"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="modulusLength*"
                      required
                      v-model="capk_data.f_modulusLength"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="exponent*"
                      :rules="[required]"
                      v-model="capk_data.f_exponent"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="exponentLength*"
                      :rules="[required]"
                      v-model="capk_data.f_exponentLength"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      label="expiryDate*"
                      :rules="[required]"
                      v-model="capk_data.f_expiryDate"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      label="checksumValue*"
                      :rules="[required]"
                      v-model="capk_data.f_checksumValue"
                    ></v-text-field>
                  </v-col>
                  <!-- <v-col cols="12">                                 
                        <v-select
                          :items="organization"
                          item-title="orgName"
                          item-value="orgId"                          
                          label="Select Organization*"                          
                          :rules="[required]"
                          v-model="capk_data.f_orgId"
                        ></v-select>                      
                      </v-col> -->
                  <v-col cols="12">
                    <!-- <v-autocomplete
                      :items="acquirers"
                      item-title="name"
                      item-value="id"
                      label="Select Acquirers"
                      multiple
                      :rules="[required]"
                      v-model="capk_data.f_acquirerList"
                    ></v-autocomplete> -->


                    <v-select
                      v-model="capk_data.f_acquirerList"
                      :items="acquirers"
                      item-title="name"
                      item-value="id"
                      label="Select Acquirers"
                      multiple
                    >
                      <template v-slot:prepend-item>
                        <v-list-item title="Select All" @click="toggle">
                          <template v-slot:prepend>
                            <v-checkbox-btn
                              :color="likesSome ? 'indigo-darken-4' : undefined"
                              :indeterminate="likesSome && !likesAll"
                              :model-value="likesAll"
                            ></v-checkbox-btn>
                          </template>
                        </v-list-item>

                        <v-divider class="mt-2"></v-divider>
                      </template>
                    </v-select>

                    
                  </v-col>
                </v-row>
              </v-container>
              <small>*{{ $t("indicateRequires") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog_update = false">{{
                $t("Close")
              }}</v-btn>
              <v-btn
                :loading="loading"
                color="success"
                type="submit"
                variant="text"
                @click="updateCapk"
                >{{ $t("Update") }}</v-btn
              >
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END UPDATE  DIALOG -->

    <!-- DELETE  DIALOG -->
    <!-- <v-dialog
              v-model="dialog_delete"
              persistent
              width="500"
            >              
              <v-card>
                <v-card-title>
                  <div class="container">
                  <span class="text-h5">Do you want to delete?</span></div>
                </v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue-darken-1" variant="text" @click="dialog_delete = false">Close</v-btn>                  
                  <v-btn color="blue-darken-1" variant="text" @click="deleteCapk">Delete</v-btn>                  
                </v-card-actions>
              </v-card>
            </v-dialog> -->

    <v-dialog v-model="dialog_delete" persistent width="400">
      <v-card>
        <template v-slot:title>
          <span class="font-weight-medium-black">Delete File</span>
        </template>

        <v-card-text class="bg-surface-light py-4">
          Are you sure you want to delete this file?
        </v-card-text>
        <v-card-actions class="mb-2 mr-2">
          <v-spacer></v-spacer>
          <v-btn color="red" variant="flat" @click="deleteCapk">{{
            $t("Delete")
          }}</v-btn>
          <v-btn variant="flat" @click="dialog_delete = false">{{
            $t("Close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- END UPDATE DIALOG -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Role",
  props: {
    msg: String,
  },
  data() {
    return {
      name: "",
      emits: ["reload"],
      acquirers: [],
      capks: [], //used
      organization: [],

      dialog: false,
      dialog_update: false,
      dialog_delete: false,

      capk_data: {
        //used
        f_capkName: "",
        f_rid: "",
        f_keyIndex: 1,
        f_hashIndicator: 1,
        f_arithIndicator: 1,
        f_modulus: "",
        f_modulusLength: 1,
        f_exponent: "",
        f_exponentLength: 1,
        f_expiryDate: "",
        f_checksumValue: "",
        f_acquirerList: [],
        f_orgId: "",
      },

      capkId: "",
      search: "",
      headers: [
        {
          title: "CapkName",
          align: "start",
          sortable: false,
          key: "capkName",
        },
        { title: "", key: "data-table-expand" },
        { title: "Rid", key: "rid" },
        { title: "KeyIndex", key: "keyIndex" },
        // { title: "HashIndicator", key: "hashIndicator" },
        // { title: "ArithIndicator", key: "arithIndicator" },
        // { title: "Modulus", key: "modulus" },
        // { title: "ModulusLength", key: "modulusLength" },
        { title: "Exponent", key: "exponent" },
        // { title: "ExponentLength", key: "exponentLength" },
        { title: "ExpiryDate", key: "expiryDate" },
        // { title: "ChecksumValue", key: "checksumValue" },
        // { title: "Acquirers", key: "acquirers", sortable: true , width: "200px"  },
        { title: "Organization", key: "organization.orgName" },
        { title: "Actions", key: "actions", sortable: false, width: "100px" },
      ],

      //form
      form: false,
      loading: true,
      exist: false,

      //snackbar
      snackbar: false,
      snackbar_text: "",
      snackbar_color: "",

      existing_rid: "",

      //pagination
      page: 1,
      itemsPerPage: 5,
      totalItems: 0,
      totalPages: 0,
      query: "",
    };
  },

  created() {},

  computed: {
    pageCount() {
      // console.log("ssss", this.totalItems + " / " + this.itemsPerPage);
      let count = Math.ceil(this.totalItems / this.itemsPerPage);
      return count;
    },

    //for select all acquirers
    likesAll () {  
        //return this.selectedFruits.length === this.fruits.length
        return this.capk_data.f_acquirerList.length === this.acquirers.length
    },
    likesSome () {
        //return this.selectedFruits.length > 0
        return this.capk_data.f_acquirerList.length > 0
    },
  },

  watch: {
    page(newPage) {
      this.page = newPage;
      this.fetchData();
      // console.log("new page", this.page);
    },
  },

  methods: {
    onSubmit() {
      if (!this.form) return;
    },

    resetInput() {
      this.capk_data.f_capkName = "";
      this.capk_data.f_rid = "";
      this.capk_data.f_keyIndex = 1;
      this.capk_data.f_hashIndicator = 1;
      this.capk_data.f_arithIndicator = 1;
      this.capk_data.f_modulus = "";
      this.capk_data.f_modulusLength = 1;
      this.capk_data.f_exponent = "";
      this.capk_data.f_exponentLength = 1;
      this.capk_data.f_expiryDate = "";
      this.capk_data.f_checksumValue = "";
      this.capk_data.f_acquirerList = [];
      this.capk_data.f_orgId = "";
    },

    resetData() {
      this.query = "";
      this.fetchData();
    },

    //for select all acquirers
    toggle () {
        if (this.likesAll) {
          this.capk_data.f_acquirerList = []
        } else {
          //this.aid_data.f_acquirerList = this.acquirers.slice()
          let i = 0;
          this.capk_data.f_acquirerList = [];
          for (i = 0; i < this.acquirers.length; i++) {
              this.capk_data.f_acquirerList.push(
                this.acquirers[i].id
              );
          }
        }
    },

    required(v) {
      return !!v || "Field is required";
    },

    min(v) {
      return v.length >= 8 || "Min 8 characters";
    },

    cakp_check(v) {
      this.checkCapk(v);
      if (this.exist) return true;
      return "CAPK exist";

      //if(this.exist) return 'Email exist'
    },

    show_toast(status, color, text) {
      this.snackbar = status;
      this.snackbar_color = color;
      this.snackbar_text = text;
    },

    compose() {
      this.dialog = true;
      this.resetInput();
      this.checkTokenExpiry();
      this.requests_handler();
    },

    compose_update(id) {
      this.capkId = id;
      this.dialog_update = true;
      this.checkTokenExpiry();
      // console.log("id", id);
      this.requests_handler2();
    },

    compose_delete(id) {
      this.capkId = id;
      this.dialog_delete = true;
    },

    requests_handler() {
      axios
        .all([
          //axios.get(window.baseurl+""+"org/get/"+this.orgId, {"headers": {'Authorization': 'Bearer ' + this.$cookies.get('accessToken')} }) ,
          axios.get(window.baseurl + "acquirers/org/" + this.orgId, {
            params:  {pagesize: 100},
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
        ])
        .then(
          axios.spread((acquirer_response) => {
            //console.log("data1", org_response.data)

            //if response data is an object // handle it as below
            /* if(org_response.status == 200){ 
                
                  this.organization = [];  //remove all items from array
                  this.organization.push(org_response.data);                          
                  console.log("organization", this.organization)                
                  

              } */

            //if response data is an array // handle it as below
            if (acquirer_response.status == 200) {
              if (
                acquirer_response.data.records != null &&
                acquirer_response.data.records.length > 0
              ) {
                let i = 0;
                this.acquirers = []; //remove all items from array
                for (i = 0; i < acquirer_response.data.records.length; i++) {
                  this.acquirers.push({
                    id: acquirer_response.data.records[i].id,
                    name: acquirer_response.data.records[i].acquirerName,
                  });
                  //console.log("acquirers", this.acquirers)
                }
              }
            }
          })
        );
    }, //end of requests_handler method

    async addCapk() {
      //this.dialog = false
      // console.log("form data", this.capk_data);
      this.checkTokenExpiry();
      try {
        let result = await axios.post(
          window.baseurl + "" + "capks",
          {
            capkName: this.capk_data.f_capkName,
            rid: this.capk_data.f_rid,
            keyIndex: this.capk_data.f_keyIndex,
            hashIndicator: this.capk_data.f_hashIndicator,
            arithIndicator: this.capk_data.f_arithIndicator,
            modulus: this.capk_data.f_modulus,
            modulusLength: this.capk_data.f_modulusLength,
            exponent: this.capk_data.f_exponent,
            exponentLength: this.capk_data.f_exponentLength,
            expiryDate: this.capk_data.f_expiryDate,
            checksumValue: this.capk_data.f_checksumValue,
            acquirersList: this.capk_data.f_acquirerList,
            //orgId:this.capk_data.f_orgId,
            organization_id: this.orgId,
            createdBy: this.userEmail,
            updatedBy: this.userEmail,
          },
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        //console.warn("result", result);
        if (result.status == 201) {
          //alert("successfull");
          //this.show_toast(true, "success", "Successful");
          // this.$root.vtoast.show({message: result.data.message})
          this.$root.vtoast.show({ message: "CAPK Created Successfully" });
          window.setInterval(() => {
            this.dialog = false;
            this.$emit("reload");
          }, this.waiting_time);
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        if (error.response.status == 417) {
          this.$root.vtoast.showError({ message: error.response.data.message });
        } else if (error.response.status == 500) {
          this.$root.vtoast.showError({ message: error.response.data.detail });
        } else {
          this.$root.vtoast.showError({ message: error.response.data.message });
        }
      }
    },

    requests_handler2() {
      axios
        .all([
          axios.get(window.baseurl + "capks/" + this.capkId, {
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
          //axios.get(window.baseurl+""+"org/get/"+this.orgId , {"headers": {'Authorization': 'Bearer ' + this.$cookies.get('accessToken')} }) ,
          axios.get(window.baseurl + "acquirers/org/" + this.orgId, {
            params:  {pagesize: 100},
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
        ])
        .then(
          axios.spread((capk_response, acquirer_response) => {
            // console.log("data1", capk_response.data);

            //get data for selected id and display data in for dialog
            if (capk_response.status == 200) {
              //this.acquirer_response = acquirer_response.data,
              // console.log("capk Data", this.capk_response);
              this.capk_data.f_capkName = capk_response.data.capkName;
              this.capk_data.f_rid = capk_response.data.rid;
              this.capk_data.f_keyIndex = capk_response.data.keyIndex;
              this.capk_data.f_hashIndicator = capk_response.data.hashIndicator;
              this.capk_data.f_arithIndicator =
                capk_response.data.arithIndicator;
              this.capk_data.f_modulus = capk_response.data.modulus;
              this.capk_data.f_modulusLength = capk_response.data.modulusLength;
              this.capk_data.f_exponent = capk_response.data.exponent;
              this.capk_data.f_exponentLength =
                capk_response.data.exponentLength;
              this.capk_data.f_expiryDate = capk_response.data.expiryDate;
              this.capk_data.f_expiryDate = capk_response.data.expiryDate;
              this.capk_data.f_checksumValue = capk_response.data.checksumValue;
              //this.capk_data.f_orgId = capk_response.data.orgId

              this.existing_rid = capk_response.data.rid;

              let i = 0;
              this.capk_data.f_acquirerList = [];
              for (i = 0; i < capk_response.data.acquirers.length; i++) {
                this.capk_data.f_acquirerList.push(
                  capk_response.data.acquirers[i].id
                );
              }
            }

            //if response data is an object // handle it as below
            /* if(org_response.status == 200){ 
                
                this.organization = [];  //remove all items from array
                this.organization.push(org_response.data);                          
                console.log("organization", this.organization)           
              
              } */

            if (acquirer_response.status == 200) {
              if (
                acquirer_response.data.records != null &&
                acquirer_response.data.records.length > 0
              ) {
                let i = 0;
                this.acquirers = []; //remove all items from array
                for (i = 0; i < acquirer_response.data.records.length; i++) {
                  this.acquirers.push({
                    id: acquirer_response.data.records[i].id,
                    name: acquirer_response.data.records[i].acquirerName,
                  });
                  //console.log("acquirers", this.acquirers)
                }
              }
            }
          })
        );
    }, //end of requests_handler 2 method

    //NOT NEEDED TO BE REMOVE
    async updateCapk1() {
      //this.dialog_update = false
      // console.log("update form role id", this.roleId);
      // console.log("update form role..", this.role_data);
      this.checkTokenExpiry();

      //check if AID exist
      if (this.existing_rid != this.capk_data.f_rid) {
        try {
          let result_capk = await axios.get(
            window.baseurl + "capk/get/" + this.capk_data.f_rid + "/capk",
            {
              headers: {
                Authorization: "Bearer " + this.$cookies.get("accessToken"),
              },
            }
          );
          // console.log("RESPONSE", result_capk);
          if (result_capk.status == 200) {
            //alert("device exist");
            this.show_toast(true, "warning", "CAPK exist");
            // console.log("EXIST", "AID exist");
            this.exist = true;
            // console.log("EXIST value 1", this.exist);
          }
        } catch (err) {
          // console.log("EXIST", "capkd does not exist");
          // console.log(err.response.data);
          if (err.response.data.status == 500) {
            this.exist = false;
            // console.log("EXIST value 2", this.exist);
          }
        }
      } else {
        // console.log("EQUAL", "true");
        this.exist = false;
      }

      //if exist do not submit to database else submit
      if (this.exist) {
        this.show_toast(true, "warning", "CAPK exist");
        // console.log("EXIST112", this.exist);
      } else {
        try {
          let result = await axios.patch(
            window.baseurl + "" + "capk/update/" + "" + this.capkId,
            {
              capkName: this.capk_data.f_capkName,
              rid: this.capk_data.f_rid,
              keyIndex: this.capk_data.f_keyIndex,
              hashIndicator: this.capk_data.f_hashIndicator,
              arithIndicator: this.capk_data.f_arithIndicator,
              modulus: this.capk_data.f_modulus,
              modulusLength: this.capk_data.f_modulusLength,
              exponent: this.capk_data.f_exponent,
              exponentLength: this.capk_data.f_exponentLength,
              expiryDate: this.capk_data.f_expiryDate,
              checksumValue: this.capk_data.f_checksumValue,
              //orgId:this.capk_data.f_orgId,
              orgId: this.orgId,
              acquirersList: this.capk_data.f_acquirerList,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$cookies.get("accessToken"),
              },
            }
          );
          console.log("update form role result", result);
          if (result.status == 200) {
            //alert("successfull updated");
            this.dialog = false;
            // this.show_toast(true, "success", "Successful");
            // this.show_toast(true, "success", "Successful");
            this.$root.vtoast.show({ message: "CAPK Updated" });
            window.setInterval(() => {
              this.$router.go();
            }, 7000);
            //this.$router.go();
          }
        } catch (error) {
          if (error.response.status == 417) {
            this.$root.vtoast.showError({
              message: error.response.data.message,
            });
          } else if (error.response.status == 500) {
            this.$root.vtoast.showError({
              message: error.response.data.detail,
            });
          } else {
            this.$root.vtoast.showError({
              message: error.response.data.message,
            });
          }
        }
      }
    },

    async updateCapk() {
      this.checkTokenExpiry();
      try {
        let result = await axios.put(
          window.baseurl + "" + "capks/" + this.capkId,
          {
            capkName: this.capk_data.f_capkName,
            rid: this.capk_data.f_rid,
            keyIndex: this.capk_data.f_keyIndex,
            hashIndicator: this.capk_data.f_hashIndicator,
            arithIndicator: this.capk_data.f_arithIndicator,
            modulus: this.capk_data.f_modulus,
            modulusLength: this.capk_data.f_modulusLength,
            exponent: this.capk_data.f_exponent,
            exponentLength: this.capk_data.f_exponentLength,
            expiryDate: this.capk_data.f_expiryDate,
            checksumValue: this.capk_data.f_checksumValue,
            //orgId:this.capk_data.f_orgId,
            organization_id: this.orgId,
            updatedBy: this.userEmail,
            acquirersList: this.capk_data.f_acquirerList,
          },
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        // console.log("update form role result", result);
        if (result.status == 200) {
          //alert("successfull updated");
          //this.show_toast(true, "success", "Successful");
          this.$root.vtoast.show({ message: result.data.message });
          this.$root.vtoast.show({ message: "CAPK Updated" });
          window.setInterval(() => {
            this.dialog = false;
            this.$emit("reload");
          }, this.waiting_time);
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        if (error.response.status == 417) {
          this.$root.vtoast.showError({ message: error.response.data.message });
        } else if (error.response.status == 500) {
          this.$root.vtoast.showError({ message: error.response.data.detail });
        } else {
          this.$root.vtoast.showError({ message: error.response.data.message });
        }
      }
    },

    async deleteCapk() {
      this.dialog_delete = false;
      this.checkTokenExpiry();
      try {
        let result = await axios.delete(
          window.baseurl + "capks/" + this.capkId,
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        if (result.status == 204) {
          //alert("successfull deleted");
          // this.$root.vtoast.show({message: result.data.message})
          this.$root.vtoast.show({ message: "CAPK Deleted" });
          window.setInterval(() => {
            this.$emit("reload");
          }, this.waiting_time);
          //this.$router.go();
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
      }
    },

    //CHECK IF CAPK IN FORM EXSIT   //NO NEED TO CHECK //TO BE REMOVE
    async checkCapk(capk) {
      // console.log("capk", capk);
      this.checkTokenExpiry();

      try {
        let result_aid = await axios.get(
          window.baseurl + "capk/get/" + capk + "/capk",
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("accessToken"),
            },
          }
        );
        // console.log("RESPONSE", result_aid);
        if (result_aid.status == 200) {
          //alert("device exist");
          this.show_toast(true, "warning", "Capk exist");
          // console.log("EXIST", "AID exist");
          this.exist = true;
          // console.log("EXIST value 1", this.exist);
        }
      } catch (err) {
        // console.log("EXIST", "aid does not exist");
        // console.log(err.response.data);
        if (err.response.data.status == 500) {
          this.exist = false;
          // console.log("EXIST value 2", this.exist);
        }
      }
    },

    async fetchData() {
      let result;
      let page2 = this.page - 1;
      this.loading = true;
      try {
        if (
          this.global_permissions.includes("ROLE_STAFF_ADMIN") ||
          this.global_permissions.includes("ROLE_STAFF_USER")
        ) {
          result = await axios.get(window.baseurl + "capks", {
            params: { page: page2 },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("capk_object", result);
          this.capks = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        } else if (
          this.global_permissions.includes("ROLE_MOD_CARD")          
        ) {
          result = await axios.get(window.baseurl + "capks/org/" + this.orgId, {
            params: { page: page2 },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("capk_object", result);
          this.capks = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
        this.loading = false;
      }
    },

    async searchCapk() {
      let result;
      let page2 = this.page - 1; //pagination starts from 1 in vue , in spring boot pgae start from zero
      this.loading = true;
      this.checkTokenExpiry();
      try {
        if (
          this.global_permissions.includes("ROLE_STAFF_ADMIN") ||
          this.global_permissions.includes("ROLE_STAFF_USER")
        ) {
          result = await axios.get(window.baseurl + "capks/search", {
            params: { page: page2, search: this.query },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("search_capk_object", result);
          this.capks = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        } else if (
          this.global_permissions.includes("ROLE_MOD_CARD")          
        ) {
          result = await axios.get(
            window.baseurl + "capks/org/search/" + this.orgId,
            {
              params: { page: page2, search: this.query },
              headers: { Authorization: "Bearer " + this.accessToken },
            }
          );

          // console.log("search_capk_object", result);
          this.capks = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
        this.loading = false;
      }
    },

    validateName(value) {
      const regex = /^[A-Za-z0-9_ ]+$/;
      return (
        regex.test(value) ||
        "Name can only be numbers, characters, space, underscore and ."
      );
    },
    validateField(value) {
      const regex = /^[A-Za-z0-9]+$/;
      return regex.test(value) || "Field can only be numbers and characters.";
    },
    validateMinMax(value) {
      if (value >= 0 && value <= 1) {
        return true;
      } else {
        return "Minimum value is 0 and maximum value is 1.";
      }
    },
  
    formattedDate(dateString) {
  // Remove the last 6 characters (which represent the timezone) instead of 11
  const dateValue = dateString.toString().slice(0, -6);
  // console.log("original date", dateString);
  // console.log("adjusted date", dateValue);

  // Create a new date object from the adjusted date string
  const date = new Date(dateValue);


  // Format the date and time using toLocaleDateString and toLocaleTimeString
  return (
    date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    }) +
    " " +
    date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    })
  );
},

},
  //get list of acquirers
  async mounted() {
    this.checkTokenExpiry();

    //get capk list
    this.fetchData();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* h3 {
    margin: 40px 0 0;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  } */
</style>
